var map = {
	"./customers/content/e-seminar.webp": 1409,
	"./customers/content/helal-ahmar.webp": 1410,
	"./customers/content/ikco.webp": 1411,
	"./customers/content/mapna.webp": 1412,
	"./customers/content/milli-1.webp": 1413,
	"./customers/content/milli.webp": 1414,
	"./customers/content/solico.webp": 1415,
	"./customers/e-seminar.png": 1614,
	"./customers/helal-ahmar.png": 1615,
	"./customers/ikco.png": 1616,
	"./customers/mapna.png": 1617,
	"./customers/milli-gold.png": 1618,
	"./customers/solico.png": 1619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2566;